import {
  FINISH_LOADING,
  START_LOADING,
  OPEN_TOAST_DIALOG,
  CLOSE_TOAST_DIALOG,
} from "./types";

export const startLoading = (execution) => {
  return {
    type: START_LOADING,
    execution: execution,
  };
};

export const finishLoading = (execution) => {
  return {
    type: FINISH_LOADING,
    execution: execution,
  };
};

export const openToastDialog = (
  toastDialogMessage = "",
  toastDialogType = "SUCCESS"
) => {
  return {
    type: OPEN_TOAST_DIALOG,
    toastDialogMessage,
    toastDialogType,
  };
};

export const closeToastDialog = () => {
  return {
    type: CLOSE_TOAST_DIALOG,
  };
};
